<template>
  <v-card width="100%" v-if="event">
    <v-toolbar color="indigo" dark dense>
      <template v-slot:extension>
        <text-copy-popup :travel-id="travelId" :critical-id="event.idCriticalEvent"
                         v-if="$vuetify.breakpoint.xsOnly"></text-copy-popup>
        <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
        <span>
<!--          {{ event.dangerousStateLocalized }} <span v-if="debugMode"-->
          <!--                                                    class="ml-2">(id = {{ event.idCriticalEvent }})</span>-->
          <template v-if="$vuetify.breakpoint.xsOnly">
            <template v-if="event.isStateConfirmed()">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="mx-2 pointer" :color="event.getColorState()" v-on="on">{{
                  event.getStateIcon()
                }}
              </v-icon>
            </template>
            <span>{{ $vuetify.lang.t(event.getStateText()) }}</span>
          </v-tooltip>

          <template v-if="event.isRetrainingState">
            <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="mx-2 pointer" v-on="on">
                {{ dangerousStateIcons[event.retrainState] }}
              </v-icon>
            </template>
            <span>{{ $vuetify.lang.t(event.getLocalizedDangerousState(event.retrainState)) }}</span>
          </v-tooltip>
          </template>
        </template>
          </template>


        <template v-if="isSpecial">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="changeCriticalMode" :color="datasetIconColor" v-on="on">
                <v-icon>{{ modeIcon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.t(modeText) }}</span>
          </v-tooltip>

        </template>

          <template v-if="isSpecial">
            <critical-statistics-filter-menu :filter-data="routeState" :filters="additionalStatisticsFilters"
                                             :is-loading="isCriticalLoading"
                                             @filter-event-values="getFilteredEventValues"></critical-statistics-filter-menu>
          </template>

          <template v-if="debugMode">
                <tooltip-basic :text="'$vuetify.sqlHelperDialog.title'" :icon="sqlIcon"
                               :emit-state="`sql-helper-dialog`"
                               @sql-helper-dialog="sqlHelperDialog = true"></tooltip-basic>
          </template>

          <settings-menu key="videoSettings" :setting="settingsType.VIDEO"></settings-menu>

        </span>
        <!--        <v-spacer></v-spacer>-->

        <v-spacer></v-spacer>

        <template v-if="previousEvent">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="changeCriticalState('previous')" v-on="on">
                <v-icon>
                  {{ leftArrow }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.previousEvent') }}</span>
          </v-tooltip>
        </template>

        <template v-if="nextEvent">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="changeCriticalState('next')" v-on="on">
                <v-icon>
                  {{ rightArrow }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.nextEvent') }}</span>
          </v-tooltip>
        </template>
      </template>
      <v-toolbar-title>
        <template v-if="!$vuetify.breakpoint.xsOnly">
          <text-copy-popup :travel-id="travelId" :critical-id="event.idCriticalEvent"></text-copy-popup>
          <span>
          {{ event.dangerousStateLocalized }} <span v-if="debugMode"
                                                    class="ml-2">(id = {{ event.idCriticalEvent }})</span>
        <template v-if="event.isStateConfirmed()">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon class="mx-2 pointer" :color="event.getColorState()" v-on="on">{{
                  event.getStateIcon()
                }}
              </v-icon>
            </template>
            <span>{{ $vuetify.lang.t(event.getStateText()) }}</span>
          </v-tooltip>

          <template v-if="event.isRetrainingState">
            <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon class="mx-2 pointer" v-on="on">
                {{ dangerousStateIcons[event.retrainState] }}
              </v-icon>
            </template>
            <span>{{ $vuetify.lang.t(event.getLocalizedDangerousState(event.retrainState)) }}</span>
          </v-tooltip>
          </template>
        </template>
        </span>
        </template>
        <template v-else>
          <span class="subtitle-1" style="white-space: normal">
            {{ event.dangerousStateLocalized }}
            <span v-if="debugMode" class="ml-2">(id = {{ event.idCriticalEvent }})</span>
          </span>
        </template>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!--      <template v-if="!$vuetify.breakpoint.xsOnly">-->

      <!--        <template v-if="debugMode">-->
      <!--          <tooltip-basic :text="'$vuetify.sqlHelperDialog.title'" :icon="sqlIcon" :emit-state="`sql-helper-dialog`"-->
      <!--                         @sql-helper-dialog="sqlHelperDialog = true"></tooltip-basic>-->
      <!--        </template>-->
      <!--        <settings-menu key="videoSettings" :setting="settingsType.VIDEO"></settings-menu>-->

      <!--        <template v-if="isSpecial">-->
      <!--          <v-tooltip top>-->
      <!--            <template v-slot:activator="{ on }">-->
      <!--              <v-btn icon @click="changeCriticalMode" :color="datasetIconColor" v-on="on">-->
      <!--                <v-icon>{{ modeIcon }}</v-icon>-->
      <!--              </v-btn>-->
      <!--            </template>-->
      <!--            <span>{{ $vuetify.lang.t(modeText) }}</span>-->
      <!--          </v-tooltip>-->
      <!--        </template>-->

      <!--        <template v-if="isSpecial">-->
      <!--          <critical-statistics-filter-menu :filter-data="routeState" :filters="additionalStatisticsFilters"-->
      <!--                                           :is-loading="isCriticalLoading"-->
      <!--                                           @filter-event-values="getFilteredEventValues"></critical-statistics-filter-menu>-->
      <!--        </template>-->

      <!--        <template v-if="previousEvent">-->
      <!--          <v-tooltip top>-->
      <!--            <template v-slot:activator="{ on }">-->
      <!--              <v-btn icon @click="changeCriticalState('previous')" v-on="on">-->
      <!--                <v-icon>-->
      <!--                  {{ leftArrow }}-->
      <!--                </v-icon>-->
      <!--              </v-btn>-->
      <!--            </template>-->
      <!--            <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.previousEvent') }}</span>-->
      <!--          </v-tooltip>-->
      <!--        </template>-->

      <!--        <template v-if="nextEvent">-->
      <!--          <v-tooltip top>-->
      <!--            <template v-slot:activator="{ on }">-->
      <!--              <v-btn icon @click="changeCriticalState('next')" v-on="on">-->
      <!--                <v-icon>-->
      <!--                  {{ rightArrow }}-->
      <!--                </v-icon>-->
      <!--              </v-btn>-->
      <!--            </template>-->
      <!--            <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.nextEvent') }}</span>-->
      <!--          </v-tooltip>-->
      <!--        </template>-->
      <!--      </template>-->

      <v-btn icon @click="sendCloseSignal">
        <v-icon>{{ closeIcon }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="px-0 py-0">
      <v-container class="px-0 py-0" fluid>
        <template v-if="debugMode || isEventRejected">
          <v-tabs v-model="tab" center-active grow :show-arrows="$vuetify.breakpoint.smAndDown">
            <v-tab :class="{'justify-start': !mobile}">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.general') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}" v-if="isEventRejected">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.rejection') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}" v-if="debugMode && event.hasCriticalParamValue()">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.criticalParamValue') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}" v-if="debugMode && event.hasTag()">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.tag') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}" v-if="debugMode && event.settings.isExisted()">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.settings') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}" v-if="debugMode && event.hasDeviceInfo()">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.deviceInfo') }}
            </v-tab>
            <v-tab :class="{'justify-start': !mobile}"
                   v-if="debugMode && (event.hasVideoTag() || event.hasVideoRoadTag())">
              {{ $vuetify.lang.t('$vuetify.map.criticalPopup.sections.titles.videoTag') }}
            </v-tab>

            <v-tabs-items v-model="tab" :touchless="$vuetify.breakpoint.smAndDown">
              <v-tab-item>
                <template v-if="!nanoUser">
                  <critical-popup-general-mobile
                    :event="event"
                    :filters="eventCriticalStatistics"
                    :raw-values="rawValues"
                    :nano-user="nanoUser"
                    :is-video-existed="isDriverVideoExisted"
                    :is-road-video-existed="isRoadVideoExisted"
                    :user-id="userId"
                    :is-forced-video="isForcedVideo"
                    :is-auto-play="isAutoPlay"
                  ></critical-popup-general-mobile>
                </template>
                <template v-else>
                  <critical-popup-general-nano
                    :event="event"
                    :filters="eventCriticalStatistics"
                    :raw-values="rawValues"
                    :is-video-existed="isDriverVideoExisted"
                    :is-road-video-existed="isRoadVideoExisted"
                    :user-id="userId"
                    :is-forced-video="isForcedVideo"
                    :is-auto-play="isAutoPlay"
                  ></critical-popup-general-nano>
                </template>

              </v-tab-item>

              <v-tab-item v-if="isEventRejected">
                <critical-popup-rejected-event :event="event"></critical-popup-rejected-event>
              </v-tab-item>

              <v-tab-item v-if="debugMode && event.hasCriticalParamValue()">
                <critical-params-value-tab :event="event"></critical-params-value-tab>
              </v-tab-item>
              <v-tab-item v-if="debugMode && event.hasTag()">
                <critical-tag-tab :event="event"></critical-tag-tab>
              </v-tab-item>
              <v-tab-item v-if="debugMode && event.settings.isExisted()" class="px-1 py-1">
                <v-row no-gutters class="mx-auto" justify="start">
                  <v-col cols="12">
                    <critical-settings :event="event"></critical-settings>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="px-1 py-1" v-if="debugMode && event.hasDeviceInfo()">
                <v-row class="mx-auto" justify="start" no-gutters>
                  <v-col cols="12">
                    <critical-device-info :event="event"></critical-device-info>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="px-1 py-1" v-if="debugMode && event.hasVideoTag()">
                <v-row class="mx-auto" justify="start" no-gutters>
                  <v-col cols="12">
                    <critical-video-tag :event="event"></critical-video-tag>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>

          </v-tabs>
        </template>
        <template v-else>
          <div class="my-1">
            <template v-if="!nanoUser">
              <critical-popup-general-mobile
                :event="event"
                :filters="eventCriticalStatistics"
                :raw-values="rawValues"
                :nano-user="nanoUser"
                :is-video-existed="isDriverVideoExisted"
                :is-road-video-existed="isRoadVideoExisted"
                :user-id="userId"
                :is-forced-video="isForcedVideo"
                :is-auto-play="isAutoPlay"
              ></critical-popup-general-mobile>
            </template>
            <template v-else>
              <critical-popup-general-nano
                :event="event"
                :filters="eventCriticalStatistics"
                :raw-values="rawValues"
                :is-video-existed="isDriverVideoExisted"
                :is-road-video-existed="isRoadVideoExisted"
                :user-id="userId"
                :is-forced-video="isForcedVideo"
                :is-auto-play="isAutoPlay"
              ></critical-popup-general-nano>
            </template>
          </div>
        </template>
      </v-container>

      <v-divider></v-divider>
    </v-card-text>
    <v-card-actions class="px-1 py-1">
      <v-container class="py-0">
        <v-row dense class="d-flex justify-center">
          <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
          <v-btn text :color="criticalStatesColors.retrainApproved" @click="retrainApprovedDialog = true">
            {{ $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.retrainApproved') }}
          </v-btn>
          <v-btn text color="light-green" @click="confirmState">
            {{ $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.confirm') }}
          </v-btn>
          <v-btn text color="orange darken-1" v-if="isSabotageEvent" @click="retrainDialog = true">
            {{ $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.retrain') }}
          </v-btn>
          <v-btn text color="red lighten-1" @click="rejectDialog = true" v-if="!isManagerRestricted">{{
              $vuetify.lang.t('$vuetify.map.criticalPopup.buttons.reject')
            }}
          </v-btn>
        </v-row>
        <v-row dense class="d-flex justify-center">
          <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
          <v-checkbox class="shrink mt-0 mx-auto px-1" v-model="event.isDemo" label="Demo"
                      @change="sendDemoChange"></v-checkbox>
          <v-checkbox class="shrink mt-0 mx-auto px-1" v-model="event.isDataset" label="Dataset"
                      @change="sendDemoChange"></v-checkbox>
          <v-checkbox class="shrink mt-0 mx-auto px-1 mr-sm-3" v-model="event.isTurning"
                      :label="$vuetify.lang.t('$vuetify.map.criticalPopup.userConfirm.isTurning')"
                      @change="sendDemoChange"></v-checkbox>
        </v-row>
        <v-row dense class="d-flex justify-center">
          <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>

          <v-checkbox class="shrink mt-0 mx-auto px-1 mr-sm-3" v-model="event.isCameraCorrect"
                      :label="$vuetify.lang.t('$vuetify.map.criticalPopup.userConfirm.isCameraCorrect')"
                      @change="sendDemoChange">
            <v-tooltip top slot="prepend" v-if="innerIndex === 0">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="my-n1" @click="allCameraCorrectDialog = true">
                  <v-icon>
                    {{ allCheckIcon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.allCameraCorrectDialog.button') }}</span>
            </v-tooltip>

          </v-checkbox>

          <v-checkbox class="shrink mt-0 mx-auto px-1 mr-sm-3" v-model="event.isLookDown"
                      :label="$vuetify.lang.t('$vuetify.map.criticalPopup.userConfirm.isLookDown')"
                      @change="sendDemoChange"></v-checkbox>

          <v-checkbox class="shrink mt-0 mx-auto px-1 mr-sm-3" v-model="event.isWearingMask"
                      :label="$vuetify.lang.t('$vuetify.map.criticalPopup.userConfirm.isWearingMask')"
                      @change="sendDemoChange">
            <v-tooltip top slot="prepend" v-if="innerIndex === 0">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="my-n1" @click="allIsWearingMaskDialog = true">
                  <v-icon>
                    {{ allCheckIcon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.t('$vuetify.map.criticalPopup.allIsWearingMaskDialog.button') }}</span>
            </v-tooltip>

          </v-checkbox>

        </v-row>
      </v-container>

    </v-card-actions>

    <retrain-dialog :dialog="retrainDialog" @close-retrain-dialog="retrainDialog = false"
                    @retrain-state="retrainState"></retrain-dialog>

    <reject-dialog :dialog="retrainApprovedDialog" @close-reject-dialog="retrainApprovedDialog = false"
                   @reject-state="retrainApproved" :is-approved="true"></reject-dialog>

    <reject-dialog :dialog="rejectDialog" @close-reject-dialog="rejectDialog = false"
                   @reject-state="rejectState"></reject-dialog>

    <confirmation-dialog :dialog="allCameraCorrectDialog"
                         :title="$vuetify.lang.t('$vuetify.map.criticalPopup.allCameraCorrectDialog.title')"
                         :text="$vuetify.lang.t('$vuetify.map.criticalPopup.allCameraCorrectDialog.text')"
                         :reject="$vuetify.lang.t('$vuetify.map.criticalPopup.allCameraCorrectDialog.reject')"
                         :confirm="$vuetify.lang.t('$vuetify.map.criticalPopup.allCameraCorrectDialog.confirm')"
                         @confirmation-dialog-closed="allCameraCorrectDialog = false"
                         @confirmation-dialog-confirmed="$emit('set-all-camera-correct-events')">
    </confirmation-dialog>

    <confirmation-dialog :dialog="allIsWearingMaskDialog"
                         :title="$vuetify.lang.t('$vuetify.map.criticalPopup.allIsWearingMaskDialog.title')"
                         :text="$vuetify.lang.t('$vuetify.map.criticalPopup.allIsWearingMaskDialog.text')"
                         :reject="$vuetify.lang.t('$vuetify.map.criticalPopup.allIsWearingMaskDialog.reject')"
                         :confirm="$vuetify.lang.t('$vuetify.map.criticalPopup.allIsWearingMaskDialog.confirm')"
                         @confirmation-dialog-closed="allIsWearingMaskDialog = false"
                         @confirmation-dialog-confirmed="$emit('set-all-mask-wearing-events')">
    </confirmation-dialog>

    <sql-helper-dialog :dialog="sqlHelperDialog" @sql-helper-dialog-close="sqlHelperDialog = false"
                       :event="event" :user-id="userId"></sql-helper-dialog>

  </v-card>
</template>

<script>
import { CriticalEvent } from '@/models/map/CriticalEvent'
import {
  criticalPopupMode,
  DangerousState,
  settingsType,
  UploadVideoTypes,
  UserCriticalEventConfirmation
} from '@/enum'
import { UPDATE_CRITICAL_EVENT_STATE } from '@/store/actions'
import { createNamespacedHelpers } from 'vuex'
import { MAP_PAGE, AUTH_MODULE } from '@/store/modules'

import Vuetify from '../../../plugins/vuetify'

import { createHelpers } from 'vuex-map-fields'

import {
  mdiAlertOctagon,
  mdiHelpBox,
  mdiTimer,
  mdiLightbulbOn,
  mdiSpeedometerMedium,
  mdiRocket,
  mdiFilterPlus,
  mdiFilterMinus,
  mdiMapMarkerDistance,
  mdiArrowLeftBold,
  mdiArrowRightBold,
  mdiClose,
  mdiFlaskEmpty,
  mdiEarth,
  mdiCheckAll,
  mdiDatabaseExport
} from '@mdi/js'

import backend from '../../../backend'
import CriticalSettings from './criticalSettings'
import CriticalDeviceInfo from './criticalDeviceInfo'
import TextCopyPopup from '../../utils/textCopyPopup'
import CriticalPopupGeneralMobile from './general/criticalPopupGeneralMobile'
import CriticalPopupGeneralNano from './general/criticalPopupGeneralNano'
import CriticalParamsValueTab from './criticalParamsValueTab'
import CriticalTagTab from './criticalTagTab'
import RetrainDialog from './userConfirmation/retrainDialog'
import { dangerousStateIcons } from '@/utils/icons'
import RejectDialog from './userConfirmation/rejectDialog'
import CriticalPopupRejectedEvent from './critical-popup-rejected-event'
import CriticalVideoTag from './criticalVideoTag'
import SettingsMenu from '../settings/settingsMenu'
import CriticalStatisticsFilterMenu from './criticalStatisticsFilterMenu'
import {
  criticalEventAdditionalStatisticsFilters, criticalStatesColors
} from '@/utils/travels'
import { TripAdditionalStatistics } from '@/models/travel/TripAdditionalStatistics'
import snackbarMixin from '../../../mixins/snackbarMixin'
import ConfirmationDialog from '@/components/utils/confirmationDialog'
import TooltipBasic from '@/components/utils/tooltipBasic'
import SqlHelperDialog from '@/components/utils/sqlHelperDialog'

const { mapFields: authFields } = createHelpers({
  getterType: `${AUTH_MODULE}/getField`
})

const { mapActions } = createNamespacedHelpers(MAP_PAGE)

export default {
  name: 'criticalPopup',
  mixins: [snackbarMixin],
  components: {
    SqlHelperDialog,
    TooltipBasic,
    ConfirmationDialog,
    CriticalStatisticsFilterMenu,
    SettingsMenu,
    CriticalVideoTag,
    CriticalPopupRejectedEvent,
    RejectDialog,
    RetrainDialog,
    CriticalParamsValueTab,
    CriticalTagTab,
    CriticalPopupGeneralNano,
    CriticalPopupGeneralMobile,
    TextCopyPopup,
    CriticalDeviceInfo,
    CriticalSettings
  },
  props: {
    event: CriticalEvent,
    travelId: Number,
    routeState: Array,
    // check which type is using in this component
    type: {
      type: String,
      default: 'vuex'
    },
    userId: Number,
    rawValues: Boolean,
    nanoUser: Boolean,
    innerIndex: Number,
    previousEvent: Boolean,
    nextEvent: Boolean,
    // previously we rewind only selected video - now all video on the map screen are affected
    isForcedVideo: {
      type: Boolean,
      default: false
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      tab: null,
      retrainDialog: false,
      retrainApprovedDialog: false,
      rejectDialog: false,
      dangerousStateIcons: dangerousStateIcons(),
      datasetDialog: false,
      allCameraCorrectDialog: false,
      allIsWearingMaskDialog: false,

      sqlHelperDialog: false,

      additionalStatisticsFilters: criticalEventAdditionalStatisticsFilters,
      eventFilteredValues: [],
      isCriticalLoading: false,

      criticalMode: criticalPopupMode.MAP,

      isDriverVideoExisted: false,
      isRoadVideoExisted: false,
      allCheckIcon: mdiCheckAll,
      mdiAlertOctagon: mdiAlertOctagon,
      mdiHelpBox: mdiHelpBox,
      mdiTimer: mdiTimer,
      mdiLightbulbOn: mdiLightbulbOn,
      mdiSpeedometerMedium: mdiSpeedometerMedium,
      mdiRocket: mdiRocket,
      mdiFilterPlus: mdiFilterPlus,
      mdiFilterMinus: mdiFilterMinus,
      mdiMapMarkerDistance: mdiMapMarkerDistance,
      leftArrow: mdiArrowLeftBold,
      rightArrow: mdiArrowRightBold,
      closeIcon: mdiClose,
      datasetIcon: mdiFlaskEmpty,
      mapIcon: mdiEarth,
      sqlIcon: mdiDatabaseExport
    }
  },
  computed: {
    ...authFields(['isAdmin', 'isSpecial', 'isDebugView', 'isManagerRestricted']),
    debugMode () {
      return (this.isAdmin || this.isDebugView) && this.rawValues
    },
    mobile () {
      return !(['xs', 'sm'].includes(this.$vuetify.breakpoint.name))
    },
    datasetIconColor () {
      if (this.criticalMode === criticalPopupMode.DATASET) {
        return 'white'
      } else {
        return this.event.dataset.isEmpty ? 'white' : 'light-green'
      }
    },
    isSabotageEvent () {
      return this.event.dangerousStateNormalized === DangerousState.CAMERA_SABOTAGE
    },
    isEventRejected () {
      return this.event.state === UserCriticalEventConfirmation.REJECT
    },
    recommendationNameLocalized () {
      const key = `$vuetify.map.criticalPopup.recommendations.${this.event.recommendationName}`
      const result = Vuetify.framework.lang.t(key)
      return result !== key ? result : null
    },
    modeIcon () {
      return this.criticalMode === criticalPopupMode.MAP ? this.datasetIcon : this.mapIcon
    },
    modeText () {
      return `$vuetify.map.criticalPopup.criticalMode.${this.criticalMode}`
    },
    eventCriticalStatistics () {
      if (this.eventFilteredValues.length === 0) {
        return {}
      } else {
        const criticalEvent = this.eventFilteredValues.find(item => item.id === this.event.idCriticalEvent)
        if (criticalEvent) {
          return criticalEvent.values
        } else {
          return {}
        }
      }
    }
  },
  methods: {
    ...mapActions([UPDATE_CRITICAL_EVENT_STATE]),
    _sendState (state, retrainState = null, rejectReason = null, rejectComment = null, demoChanged = false) {
      // TODO: technically, demoChanged is incorrect naming - stateNotChanged is better
      this.$emit('critical-event-confirmed', {
        event: this.event,
        state,
        retrainState,
        rejectReason,
        rejectComment,
        demoChanged,
        innerIndex: this.innerIndex
      })
    },
    confirmState () {
      this._sendState(UserCriticalEventConfirmation.APPROVE)
    },
    rejectState (data) {
      this._sendState(UserCriticalEventConfirmation.REJECT, data.retrainState, data.rejectReason, data.rejectComment)
    },
    retrainApproved (data) {
      this._sendState(UserCriticalEventConfirmation.APPROVE, data.retrainState, data.rejectReason, data.rejectComment)
    },
    retrainState (value) {
      this._sendState(UserCriticalEventConfirmation.RETRAIN, value)
    },
    changeCriticalState (direction) {
      this.$emit('critical-event-change-request', { direction, innerIndex: this.innerIndex })
    },
    switchCriticalState () {
      this.changeCriticalState('next')
    },
    sendCloseSignal () {
      this.$emit('close-critical-event')
    },
    changeCriticalMode () {
      if (this.criticalMode === criticalPopupMode.MAP) {
        this.criticalMode = criticalPopupMode.DATASET
      } else {
        this.criticalMode = criticalPopupMode.MAP
      }
      this.$emit('critical-mode-changed', this.criticalMode)
    },
    resetCriticalMode () {
      this.criticalMode = criticalPopupMode.MAP
    },
    async videoExists () {
      this.isDriverVideoExisted = false
      this.isRoadVideoExisted = false

      try {
        await backend.checkCriticalVideoExistence({
          user: this.userId,
          timestamp: this.event.datetime.getTime(),
          'video_type': UploadVideoTypes.DRIVER
        })

        this.isDriverVideoExisted = true
      } catch (e) {
        this.isDriverVideoExisted = false
      }

      try {
        await backend.checkCriticalVideoExistence({
          user: this.userId,
          timestamp: this.event.datetime.getTime(),
          'video_type': UploadVideoTypes.ROAD
        })

        this.isRoadVideoExisted = true
      } catch (e) {
        this.isRoadVideoExisted = false
      }
    },
    sendDemoChange () {
      // console.log('sendDemoChange', value, this.event.isDemo)
      this._sendState(this.event.state, this.event.retrainState, this.event.rejectReason, this.event.rejectComment, true)
    },
    async getFilteredEventValues () {
      if (this.event) {
        this.isCriticalLoading = true
        try {
          const result = await backend.fetchCriticalAdditionalStatistics({
            datetimestart: this.event.datetimestart.getTime(),
            user_id: this.userId,
            filters: this.additionalStatisticsFilters
          })

          this.eventFilteredValues = result.data.map(item => ({
            id: item.id,
            values: new TripAdditionalStatistics({ ...item.values })
          }))
        } catch (e) {
          console.error(e)
          this.openFailureSnackbar(`$vuetify.map.mapDialog.tripAdditionalStatisticsFailure`)
        } finally {
          this.isCriticalLoading = false
        }
      }
    }
  },
  created () {
    this['criticalPopupMode'] = criticalPopupMode
    this['settingsType'] = settingsType
    this['criticalStatesColors'] = criticalStatesColors
  },
  watch: {
    event: {
      immediate: true,
      async handler (value) {
        await this.videoExists()
      }
    },
    'event.isDemo' (newValue, oldValue) {
      // console.log('event.isDemo', newValue, oldValue, this.event.isDemo)
      // this._sendState(this.event.state, this.event.retrainState, this.event.rejectReason, this.event.rejectComment)
    }
  }
}
</script>

<style scoped>

.v-list-item--dense, .v-list--dense .v-list-item {
  min-height: 20px !important;
}

</style>
